module.exports = __webpack_public_path__ + "static/media/backgroundGames.91fa2313.png";